import React ,{useState,useEffect}from 'react'
import Dropdown from 'react-bootstrap/Dropdown';
import * as Icon from "react-bootstrap-icons";
import axios from "axios";
import { APIKEY } from "../Config/Config";
const Header = () => {
  const[Tokens,setTokens] = useState('')
  const[userProfilephoto,setuserProfilephoto] = useState('')
  useEffect(()=>{
    const getdata = JSON.parse(localStorage.getItem('Hrtech_token'))
    const URL = window.location.pathname;
    const paths = URL.split("/");
  const currentpath = paths[1];
 
    if(getdata){
      var tokenVal = JSON.parse(atob(getdata.split('.')[1]));
      setTokens(tokenVal)
      
    }
    
    getAll(tokenVal._id);
  },[])
 const getAll =(id)=> {
    axios.get(`${APIKEY}/Users/${id}`).then((res) => {
      setuserProfilephoto(res.data.Profilephoto)
      console.log("data userrr", res.data);
    });
  }
  const LogoutClick =()=>{
    localStorage.clear();
    window.location.href="/login"
  }
  return (
    <div className='top-header'> 
    <div className='d-flex justify-content-end'>
    <div className='me-3'>
    <Dropdown>
    <Dropdown.Toggle align={{ lg: 'start' }} id="dropdown-basic" className='dropdown-notifica d-flex align-content-center justify-content-center'>
      <div className='d-flex align-content-center justify-content-center'><Icon.Bell />
</div>
    </Dropdown.Toggle>
    <Dropdown.Menu className='notificationlis'>
    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
      <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
      <Dropdown.Item href="#/action-3">Logout</Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
  </div>
      <div>
    <Dropdown>
    <Dropdown.Toggle id="dropdown-basic" className='dropdown-top d-flex align-content-center justify-content-center'>
      <div className='d-flex align-content-center justify-content-center'><img src={`${APIKEY}/News_image/${userProfilephoto}`} /><span className='text-dark ms-2 pe-3 fs-6'>Hi {Tokens.Name}</span></div>
    </Dropdown.Toggle>
    <Dropdown.Menu className='notificinfo'>     
      <Dropdown.Item href="" onClick={LogoutClick}>Logout</Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
  </div>


  

  </div>
  </div>
  )
}

export default Header